import Decimal from 'decimal.js';

// Money and rates are never floats. 28 significant digits is far more than any
// FX use needs, and ROUND_HALF_EVEN avoids the upward bias of HALF_UP when a
// long series of roundings accumulates.
Decimal.set({ precision: 28, rounding: Decimal.ROUND_HALF_EVEN, toExpNeg: -12, toExpPos: 21 });

export { Decimal };

/** Anything that can be coerced into a Decimal without losing intent. */
export type Numeric = Decimal | number | string;

export const D = (v: Numeric): Decimal => (v instanceof Decimal ? v : new Decimal(v));

export const ZERO = new Decimal(0);
export const ONE = new Decimal(1);

/** Serialise a Decimal for JSON/HTTP. Fixed notation, no exponent surprises. */
export const toStr = (v: Decimal, dp?: number): string =>
  dp === undefined ? v.toFixed() : v.toFixed(dp);

export const isZero = (v: Decimal): boolean => v.isZero();

/** Sign-safe minimum of two non-negative magnitudes. */
export const minAbs = (a: Decimal, b: Decimal): Decimal => (a.abs().lt(b.abs()) ? a.abs() : b.abs());
